import script from "./Agenda.vue?vue&type=script&setup=true&lang=js"
export * from "./Agenda.vue?vue&type=script&setup=true&lang=js"

import "./Agenda.vue?vue&type=style&index=0&id=06cbc83d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06cbc83d"]])

export default __exports__